/**
 * @packageDocumentation
 * @module dom/is
 */

import is_custom_element from './is_custom_element';

export interface IsElement {
  /**
   * Is the element a HTML5 element or a defined custom element (the code is loaded and ready)?
   * @param el is the node or element a custom element
   */
  (el: unknown): el is HTMLElement;
}

/**
 * { @link IsElement }
 */
export default (el: Object): el is HTMLElement => {
  if (!el) {
    return false;
  }

  const isHTMLElement = (el['localName'] || '').indexOf('-') < 0;

  return isHTMLElement || is_custom_element(el);
};
